import { useAuth } from '../../../stores';

import LoginStepCheck from './LoginStepCheck';
import LoginStepEnroll from './LoginStepEnroll';
import LoginStepRecoveryCodes from './LoginStepRecoveryCodes';

const stepForms = {
  secondFactorCheck: LoginStepCheck,
  secondFactorEnroll: LoginStepEnroll,
  recoveryCodesSave: LoginStepRecoveryCodes,
};

function LoginSteps() {
  const { auth } = useAuth();
  const StepForm = stepForms[auth.server.loginPending?.steps?.[0]];

  if (!StepForm) return null;

  return <StepForm />;
}

export default LoginSteps;
